export const supportedLanguages = ['en-US', 'en-GB', 'it', 'fr-FR', 'de', 'es-ES'];
export const defaultLanguage = 'en-US';
export const genericLanguageMap = [
  {
    languageAbbreviation: 'es',
    useLanguage: 'es-ES'
  },
  {
    languageAbbreviation: 'fr',
    useLanguage: 'fr-FR'
  }
];
export const translations = {
  'en-US': {
    userMenu: {
      login: 'Login',
      logout: 'Logout',
      selectCompany: 'Select Company'
    },
    selectCompany: {
      selectCompany: 'Select Company',
      company: 'Company',
      placeholder: 'Search companies',
      done: 'Done',
      loading: 'Loading...',
      errorTitle: 'Error',
      errorMessage: 'Impossible to select the company, the user does not have the rights'
    }
  },
  de: {
    userMenu: {
      login: 'Anmelden',
      logout: 'Abmelden',
      selectCompany: 'Unternehmen auswählen'
    },
    selectCompany: {
      selectCompany: 'Unternehmen auswählen',
      company: 'Unternehmen',
      placeholder: 'Unternehmen suchen',
      done: 'Fertig',
      loading: 'Laden...',
      errorTitle: 'Fehler',
      errorMessage: 'Die Firma kann nicht ausgewählt werden, der Benutzer hat keine Rechte'
    }
  },
  'es-ES': {
    userMenu: {
      login: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      selectCompany: 'Seleccionar empresa'
    },
    selectCompany: {
      selectCompany: 'Seleccionar empresa',
      company: 'Empresa',
      placeholder: 'Buscar empresas',
      done: 'Hecho',
      loading: 'Cargando...',
      errorTitle: 'Error',
      errorMessage: 'Imposible seleccionar la empresa, el usuario no tiene los derechos'
    }
  },
  'fr-FR': {
    userMenu: {
      login: 'Connexion',
      logout: 'Déconnexion',
      selectCompany: 'Sélectionner une entreprise'
    },
    selectCompany: {
      selectCompany: 'Sélectionner une entreprise',
      company: 'Entreprise',
      placeholder: 'Rechercher une entreprise',
      done: 'Terminé',
      loading: 'Chargement...',
      errorTitle: 'Erreur',
      errorMessage: "Impossible de sélectionner la compagnie, l'utilisateur n'a pas les droits"
    }
  },
  it: {
    userMenu: {
      login: 'Accedi',
      logout: 'Disconnetti',
      selectCompany: 'Seleziona azienda'
    },
    selectCompany: {
      selectCompany: 'Seleziona azienda',
      company: 'Azienda',
      placeholder: 'Cerca aziende',
      done: 'Fatto',
      loading: 'Caricamento...',
      errorTitle: 'Errore',
      errorMessage: "Impossibile selezionare l'azienda, l'utente non ha i diritti"
    }
  },
  'en-GB': {
    userMenu: {
      login: 'Login',
      logout: 'Logout',
      selectCompany: 'Select company'
    },
    selectCompany: {
      selectCompany: 'Select company',
      company: 'Company',
      placeholder: 'Search companies',
      done: 'Done',
      loading: 'Loading...',
      errorTitle: 'Error',
      errorMessage: 'Impossible to select the company, the user does not have the rights'
    }
  }
};
